const { errorResponse } = require('../general')
const { default: useSWR } = require('swr')
const { gql, request } = require('graphql-request')

module.exports = class BaseGraph
{
    constructor(apiDomain, path)
    {
        this.endpoint = apiDomain + path
    }

    /** Standard Request Methods **/

    async request(query, args, type=null, allData=false)
    {
        // Define the headers
        const headers = {
          // Add your custom header here
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': '*'

        };

        try {
            let res = await request(this.endpoint, gql`${query}`, args, headers)
            if (allData) {
                return res;
            }
            return type ? res[type] : null
        } catch (error) {
            return { err: errorResponse(error) }
        }
    }

    /** SWR Request Methods **/

    swrRequest(query, options, type=null)
    {
        const fetcher = query => request(this.endpoint, query)

        const { data, error } = useSWR(
            `${query}`,
            fetcher,
            options
        )

        return {
            data: data ? (type ? data[type] : data) : data,
            isLoading: !error && !data,
            isError: error
        }
    }

    swrParsedRequest(query, options, type, property)
    {
        const fetcher = query => request(this.endpoint, query)

        const { data, error } = useSWR(
            `${query}`,
            fetcher,
            options
        )

        return {
            data: data ? (data[type][property] ? JSON.parse(data[type][property]) : data) : data,
            isLoading: !error && !data,
            isError: error
        }
    }

    /**
     * Note: Ecountering issues on dependent fetching with SWR requests using GQL 
     */
    swrRequestGQL(query, args, options, type=null)
    {
        const fetcher = query => request(this.endpoint, query, args)

        const { data, error } = useSWR(
            () => gql`${query}`,
            fetcher,
            options
        )

        return {
            data: data ? (type ? data[type] : data) : data,
            isLoading: !error && !data,
            isError: error
        }
    }

    /**
     * Note: Ecountering issues on dependent fetching with SWR requests using GQL 
     */
    swrParsedRequestGQL(query, args, options, type, property)
    {
        const fetcher = query => request(this.endpoint, query, args)

        const { data, error } = useSWR(
            () => gql`${query}`,
            fetcher,
            options
        )

        return {
            data: data ? (data[type][property] ? JSON.parse(data[type][property]) : data) : data,
            isLoading: !error && !data,
            isError: error
        }
    }

    /** Support Methods **/

    queryFields(fields, fieldString="")
    {
        fieldString += "{";
        for (var i = 0; i < fields.length ; i++)
        {
            var field = fields[i]
            if (typeof field !== 'string')
            {
                var key = Object.keys(field)[0]
                fieldString += key
                fieldString += `${this.queryFields(field[key])},`
            }
            else
            {
                fieldString += `${field},`
            }
        }
        fieldString += "}"

        return fieldString
    }

    queryParams(params, paramString="")
    {
        for (const key in params)
        {
            if (typeof params[key] === 'string')                
                paramString += `${key}: "${params[key]}", `
            else if (Array.isArray(params[key]))
                paramString += `${key}: ${JSON.stringify(params[key])}, `
            else
                paramString += `${key}: ${params[key]}, `
        }
        return paramString
    }

    queryString(type, fields, params)
    {
        var queryParams = ""
        if (Object.keys(params).length != 0)
            queryParams = `(${this.queryParams(params)})`
        return `{
            ${type}${queryParams}
            ${this.queryFields(fields)}
        }`
    }
}